import React from "react";

const variantClasses = {
	default: "border-none bg-primary text-white hover:bg-primary/90",
	destructive: "border-none bg-red-500 text-white hover:bg-red-600",
	outline: "border border-solid border-gray-300 bg-white hover:bg-gray-50 text-gray-900",
	secondary: "border-none bg-gray-100 text-gray-900 hover:bg-gray-200",
	ghost: "border-none bg-transparent hover:bg-gray-100 text-gray-900",
	link: "border-none text-primary underline hover:no-underline",
};

const sizeClasses = {
	default: "h-10 px-4 py-2 text-sm",
	sm: "h-9 px-3 text-sm",
	lg: "h-11 px-8 text-base",
	icon: "h-10 w-10 p-0 flex items-center justify-center",
	outline: "border border-gray-300 text-gray-800 hover:bg-gray-100",
};

const Button = React.forwardRef(
	({ variant = "default", size = "default", className = "", ...props }, ref) => {
		return (
			<button
				type={"button"}
				ref={ref}
				className={`cursor-pointer inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
				{...props}
			/>
		);
	}
);

Button.displayName = "Button";

export default Button;
